<div class="row">
	<div class="col col-4">
		<span i18n="Common|Height">Height - back</span>:
	</div>
	<div class="col col-6">
		<app-numeric-textbox #numBack [value]="projectBackHeight" [min]="minBackHeight"
			[max]="maxBackHeight"
			[disabled]="projectService.getLockStatusOfProjProp() || backHeightLocked"></app-numeric-textbox> mm
	</div>
	<div class="col col-2">
		<button kendoButton [svgIcon]="backHeightLocked ? projectService.svgIcons.lockIcon : projectService.svgIcons.unlockIcon"
			[disabled]="projectService.readOnly || backHeightLocked" (click)="changePropertyLock('backHeight')"
			fillMode="outline" themeColor="primary" style="width: 100%" [(selected)]="backHeightLocked" toggable="true">
		</button>
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span i18n="Common|Height - front">Height - front</span>:
	</div>
	<div class="col col-6">
		<app-numeric-textbox #numFront [value]="newProjectFrontHeight" [min]="minFrontHeight" [max]="maxFrontHeight"
			[disabled]="projectService.template.isFlat || projectService.getLockStatusOfProjProp() || frontHeightLocked"></app-numeric-textbox>
		mm
	</div>
	<div class="col col-2">
		<button kendoButton [svgIcon]="frontHeightLocked ? projectService.svgIcons.lockIcon : projectService.svgIcons.unlockIcon"
			[disabled]="projectService.readOnly || frontHeightLocked" (click)="changePropertyLock('frontHeight')"
			fillMode="outline" themeColor="primary" style="width: 100%" [(selected)]="frontHeightLocked" toggable="true">
		</button>
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span i18n="Project details|Drop angle">Drop angle</span>:
	</div>
	<div class="col col-6">
		<app-numeric-textbox #numDrop [value]="projectDropAngle" [min]="projectService.template.minDropAngle"
			[max]="projectService.template.maxDropAngle" [step]="0.1" [decimals]="1" [format]="'n1'"
			[disabled]="projectService.getLockStatusOfProjProp() || projectService.template.minDropAngle == projectService.template.maxDropAngle || dropAngleLocked">
		</app-numeric-textbox>&nbsp;&deg;
	</div>
	<div class="col col-2">
		<button kendoButton [svgIcon]="dropAngleLocked ? projectService.svgIcons.lockIcon : projectService.svgIcons.unlockIcon"
			[disabled]="projectService.readOnly || dropAngleLocked" (click)="changePropertyLock('dropAngle')"
			fillMode="outline" themeColor="primary" style="width: 100%" [(selected)]="dropAngleLocked" toggable="true">
		</button>
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span i18n="Common|Width">Width</span>:
	</div>
	<div class="col col-8">
		<app-numeric-textbox #numWidth [value]="projectWidth" [min]="projectService.template.minWidth"
			[max]="projectService.template.maxWidth"
			[disabled]="projectService.getLockStatusOfProjProp()"></app-numeric-textbox> mm
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span i18n="Common|Depth">Depth</span>:
	</div>
	<div class="col col-8">
		<app-numeric-textbox #numDepth [value]="projectDepth" [min]="projectService.template.minDepth"
			[max]="projectService.template.maxDepth"
			[disabled]="projectService.getLockStatusOfProjProp()"></app-numeric-textbox> mm
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span i18n="Project details|Height (back - front)">Back - front</span>:
	</div>
	<div class="col col-8">
		<app-numeric-textbox [value]="frontDiff" [disabled]="true"></app-numeric-textbox> mm
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span i18n="Common|Country">Country</span>:
	</div>
	<div class="col col-8">
		<kendo-dropdownlist [data]="countries" style="width:100px" [disabled]="true"
			[(ngModel)]="projectService.template.country"></kendo-dropdownlist>
	</div>
</div>
<div class="row">
	<div class="col col-4">
		<span i18n="Common|Snow zone">Snow zone</span>:
	</div>
	<div class="col col-8">
		<kendo-dropdownlist [data]="snowZones" style="width:100px" [disabled]="true"
			[(ngModel)]="projectService.template.snowZone"></kendo-dropdownlist>
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span i18n="Common|Wind zone">Wind zone</span>:
	</div>
	<div class="col col-8">
		<kendo-dropdownlist [data]="windZones" valueField="zone" textField="label" [valuePrimitive]="true"
			style="width:100px" [disabled]="true" [(ngModel)]="projectService.template.windZone"></kendo-dropdownlist>
	</div>
</div>

<!-- <div class="row">
			<div class="col col-4"><span i18n="Common|Left elongment">Left elongment</span>:</div>
			<div class="col col-8">
				<app-numeric-textbox #numElongLeft [value]="projectElongLeft" [disabled]="projectService.getLockStatusOfProjProp()" [min]="0" [max]="6999"></app-numeric-textbox> mm
			</div>
		</div>

		<div class="row">
			<div class="col col-4"><span i18n="Common|Right elongment">Right elongment</span>:</div>
			<div class="col col-8">
				<app-numeric-textbox #numElongRight [value]="projectElongRight" [disabled]="projectService.getLockStatusOfProjProp()" [min]="0" [max]="6999"></app-numeric-textbox> mm
			</div>
		</div>
		-->
<div class="row">
	<div class="col col-4"><span i18n="Project details|'Form sides' label">Form sides</span>:</div>
	<div class="col col-8">
		<kendo-dropdownlist style="width: 100%" [data]="projectService.template.formSides" textField="name"
			valueField="id" [listHeight]="400" [(ngModel)]="formSideId" [valuePrimitive]="true"
			[disabled]="projectService.getLockStatusOfProjProp()">
		</kendo-dropdownlist>
	</div>
</div>

<div class="row">
	<div class="col col-4"><span i18n="Project details|'Fastening type' label">Fastening type</span>:</div>
	<div class="col col-8">
		<kendo-dropdownlist style="width: 100%" [data]="projectService.template.fastenings" textField="name"
			valueField="id" [listHeight]="400" [(ngModel)]="fasteningId" [valuePrimitive]="true"
			[disabled]="projectService.getLockStatusOfProjProp()">
		</kendo-dropdownlist>
	</div>
</div>

<div class="row">
	<div class="col col-4"><span i18n="Project details|'Rear type' label">Rear type</span>:</div>
	<div class="col col-8">
		<kendo-dropdownlist style="width: 100%" [data]="projectService.getRears()" textField="name" valueField="id"
			[listHeight]="400" [(ngModel)]="rearId" [valuePrimitive]="true"
			[disabled]="projectService.getLockStatusOfProjProp()">
		</kendo-dropdownlist>
	</div>
</div>

<div class="row">
	<div class="col col-4"><span i18n="Project details|'Front type' label">Front type</span>:</div>
	<div class="col col-8">
		<kendo-dropdownlist style="width: 100%" [data]="projectService.template.fronts" textField="name" valueField="id"
			[listHeight]="400" [(ngModel)]="frontId" [valuePrimitive]="true"
			[disabled]="projectService.getLockStatusOfProjProp()">
		</kendo-dropdownlist>
	</div>
</div>

<div class="row">
	<div class="col col-4"><span i18n="Common|Bars">Bars</span>:</div>
	<div class="col col-2" style="padding-right: 1px;">
		<app-numeric-textbox #numBars [value]="projectBarsCount" [min]="projectService.template.staticBarsCount"
			[max]="projectService.template.staticBarsCount * 10" [step]="1" style="min-width: 70px"
			[disabled]="projectService.getLockStatusOfProjProp()">
		</app-numeric-textbox>
	</div>
	<div class="col col-4">
		<kendo-dropdownlist style="width: 95%; margin-left: 3px;" [data]="projectService.template.bars"
			textField="name" valueField="id" [(ngModel)]="barId" [valuePrimitive]="true"
			[disabled]="'true'">
		</kendo-dropdownlist>
	</div>
	<div class="col col-2">
		<button kendoButton [svgIcon]="projectService.svgIcons.justifyContentAroundIcon"
			[disabled]="projectService.readOnly || profileService.barsJustified" style="width: 100%" (selectedChange)="barsSelectedChange($event)"
            [toggleable]="true" [selected]="profileService.barsJustified"
			fillMode="outline" themeColor="primary">
		</button>
	</div>
</div>

<div class="row">
	<div class="col col-4"><span i18n="Common|Columns">Columns</span>:</div>
	<div class="col col-2" style="padding-right: 1px;">
		<app-numeric-textbox #numCols [value]="projectColsCount"
			style="min-width: 70px" [disabled]="true">
		</app-numeric-textbox>
	</div>
	<div class="col col-4"></div>
	<div class="col col-2">
		<button kendoButton [svgIcon]="projectService.svgIcons.justifyContentAroundIcon" 
			[disabled]="projectService.readOnly || profileService.columnsJustified" (selectedChange)="colsSelectedChange($event)"
            [toggleable]="true" [selected]="profileService.columnsJustified"
			fillMode="outline" themeColor="primary" style="width: 100%">
		</button>
	</div>
</div>

<app-color-palette [colorsPalette]="projectService.template.colors"></app-color-palette>

<div class="row" style="margin-top: 5px; margin-bottom: 5px;">
	<div class="col col-4">
		<span i18n="Common|Lock">Locked</span>:
	</div>
	<div class="col col-8">
		<input type="checkbox" kendoCheckBox style="width: 20px; height: 20px;" [(ngModel)]="lockStatus" (click)="changeLock()" [disabled]="projectService.readOnly">
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span i18n="Common|Offer">Offer</span>:
	</div>
	<div class="col col-8">
		<app-offer-popup></app-offer-popup>
	</div>
</div>


<div *ngIf="projectService.showDebugInfo" class="testMode">
	<div class="row">
		<div class="col col-4">Channels:</div>
		<div class="col col-8">{{ this.projectService.channelsTotal }}</div>
	</div>
	<div class="row">
		<div class="col col-4">Remote:</div>
		<div class="col col-8">{{ this.projectService.remote?.name }}</div>
	</div>
</div>

<!-- <h5 class="proj-valid" *ngIf="projectService.errors?.length == 0" i18n="Common|Project is valid">Project is valid</h5>

<kendo-card class="minor" style="width: 100%" *ngIf="projectService.errors?.length > 0">
	<kendo-card-header>
		<div class="row">
			<div class="col col-12 proj-notvalid" i18n="Common|Project validation">Project validation</div>
		</div>
	</kendo-card-header>
	<kendo-card-body>
		<ul>
			<li *ngFor="let d of projectService.errors">{{ d }}</li>
		</ul>
	</kendo-card-body>
</kendo-card> -->

<kendo-card class="minor" style="width: 100%" *ngIf="projectService.warnings?.length > 0">
	<kendo-card-header>
		<div class="row">
			<div class="col col-12 warning">Warnings</div>
		</div>
	</kendo-card-header>
	<kendo-card-body>
		<ul>
			<li *ngFor="let d of projectService.warnings">{{ d }}</li>
		</ul>
	</kendo-card-body>
</kendo-card>

<app-wait [show]="showLoading" [message]="messageLoading"></app-wait>

<!-- dialogs -->

<app-confirm-dialog [dialogOpened]="isConfirmDialogOpened" [dialogMessage]="confirmDialogMessage"
	(dialogAction)="onConfirmDialogAction($event)">
</app-confirm-dialog>

<div *ngIf="projectService.showDebugInfo"
	class="testMode">
	<div class="row">
		<div class="col col-4">minFrontHeight:</div>
		<div class="col col-8">{{ minFrontHeight }} mm</div>
	</div>
	<div class="row">
		<div class="col col-4">maxFrontHeight:</div>
		<div class="col col-8">{{ maxFrontHeight }} mm</div>
	</div>
	<div class="row">
		<div class="col col-4">minBackHeight:</div>
		<div class="col col-8">{{ minBackHeight }} mm</div>
	</div>
	<div class="row">
		<div class="col col-4">maxBackHeight:</div>
		<div class="col col-8">{{ maxBackHeight }} mm</div>
	</div>
</div>